import React, { useState, useEffect } from 'react';
import { Card, ButtonBase, CardMedia } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import * as NotificationService from '../../services/notification';
import Image from '../../images/dummyProfilePicture.jpg';
import { useAvatarUploadStyles } from './style';

interface Props {
  onChange: (image: File) => void;
  avatarUrl?: string;
}
const allowedExtensions = ['jpeg', 'bmp', 'gif', 'png', 'tiff', 'jpg'];

export function AvatarUpload(props: Props) {
  const { t } = useTranslation();
  const [previewImage, setPreviewImage] = useState(Image);
  const avatarUploadStyle = useAvatarUploadStyles();

  useEffect(() => {
    setPreviewImage(props.avatarUrl || Image);
  }, [props.avatarUrl]);

  async function handleInputChange(event: any) {
    if (event.target.files.length !== 0) {
      if (checkExtension(event.currentTarget.files[0])) {
        const image = document.createElement('img');
        image.src = window.URL.createObjectURL(event.currentTarget.files[0]);
        if (image.src) {
          setPreviewImage(image.src);
          props.onChange(event.currentTarget.files[0]);
          image.onload = function() {
            window.URL.revokeObjectURL(image.src);
          };
        } else {
          setPreviewImage(props.avatarUrl || Image);
        }
      }
    }
  }

  function checkExtension(file: File): boolean {
    if (file) {
      const allowed = allowedExtensions.some(elem => file.name.includes(elem));
      if (allowed) return true;
      else {
        NotificationService.showError(t('unsupported_image_type'));
        return false;
      }
    }
    return true;
  }

  return (
    <Card className={avatarUploadStyle.card}>
      <ButtonBase component='label'>
        <CardMedia
          component='img'
          className={avatarUploadStyle.cardMedia}
          image={previewImage}
          title={t('profile_image')}
        />
        <input
          accept='.jpg,.bmp,.gif,.png,.tiff,.jpeg'
          type='file'
          className={avatarUploadStyle.input}
          onChange={handleInputChange}
        />
      </ButtonBase>
    </Card>
  );
}
